<template>
  <basic-container id="warehouse2022">
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               v-if="reWrite"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               :before-close="beforeClose"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-error"
                   plain
                   @click="stopAll">停用
        </el-button>
      </template>
      <template slot="projectIdSearch">
        <el-select
          v-model="projectName"
          @change="searchProjectChange"
        >
          <el-option
            v-for="item in projectList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag
          :type="
            scope.row.status == 1
              ? 'success'
              : scope.row.status == 0
              ? 'danger'
              : 'warning'
          "
        >
          {{scope.row.status==1?'正常':'停用'}}
        </el-tag>
      </template>
      <template slot="lockFlag" slot-scope="scope">
        <el-tag
          :type="
            scope.row.lockFlag == 0
              ? 'success'
              : scope.row.lockFlag == 1
              ? 'danger'
              : 'warning'
          "
        >
          {{scope.row.lockFlag==1?'锁定':'未锁定'}}
        </el-tag>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="scope.row.status==1"
          icon="el-icon-error"
          @click="stop(scope.row)"
          style="color: #409EFF"
        >停用
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="scope.row.status==0"
          icon="el-icon-success"
          @click="start(scope.row)"
          style="color: #409EFF"
        >启用
        </el-button>
      </template>
      <template slot="userIdsForm" slot-scope="scope">
        <UserSelector :projectId="form.projectId"
                      :remainUserListInside.sync="userList"
                      :single="false"
                      :required="true"

        />
      </template>
      <template slot="emptyDisplayFlagForm" slot-scope="scope">
        <el-radio-button
          :border="false"
          v-for="(item, index) in workStatusList_"
          :key="index"
          :label="item.dictKey"
        >{{ item.dictValue + "(" + item.count + ")" }}</el-radio-button
        >
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update, stop, change} from "@/api/crmedical/warehouse/warehouse";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import UserSelector from "@/views/components/user-edit-box";

  export default {
    components: {
      UserSelector
    },
    data() {
      return {
        projectName: '',
        flag:'',
        form: {

        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        emptyDisplayFlagList:[],
        selectionList: [],
        projectList: [],
        userList:[],
        passCloseDialog:false,
        reWrite: false,
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          index: true,
          viewBtn: true,
          delBtn: false,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 12,
          stripe:true,
          dialogClickModal:false,
          align: 'left',
          column: [

            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              searchslot: true,
              span: 12,
              searchClearable: false,
              editDisabled: true,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {label: 'name', value: 'id'},
              rules: [
                {
                  required: true,
                  message: "请选择项目",
                  trigger: "change"
                }
              ]
            },
            {
              label: "工作状态",
              prop: "status",
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              slot: true,
              viewDisabled: false,
              search: false,
              dataType: 'number',
              align:"center",
              dicData: [
                {label: '启用', value: 1},
                {label: '停用', value: 0},
              ],
            },
            {
              label: "仓库名称",
              prop: "name",
              search: true,
              showWordLimit: true,
              maxlength: 20,
              rules: [{
                required: true,
                message: "请输入仓库名称",
                trigger: "change"
              }]
            },
            {
              label: "仓库编码",
              prop: "code",
              showWordLimit: true,
              maxlength: 30,
              rules: [{
                required: true,
                message: "请输入仓库编码",
                trigger: "change"
              }]
            },
            {
              label: "是否锁定",
              prop: "lockFlag",
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              search: false,
              slot: true,
              dataType: 'number',
              dicData: [
                {label: '锁定', value: 1},
                {label: '未锁定', value: 0},
              ],
            },
            {
              label: "联系电话",
              prop: "tel",
              showWordLimit: true,
              maxlength: 14,
              rules: [{
                required: true,
                message: "请输入仓库联系电话",
                trigger: "change"
              },
                {pattern: /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/, message: '请输入正确得座机或手机号码！'},
              ]
            },
            {
              label: "库管",
              prop: "userName",
              addDisplay: false,
              editDisplay: false,
              span: 24,
            },

            {
              label: "库管",
              prop: "userIds",
              viewDisplay: false,
              hide: true,
              span: 24,
              formslot:true,
              rules: [{
                required: true,
                message: "请选择库管",
                trigger: "change"
              }]
            },
            {
              label: '备注信息',
              prop: 'description',
              type: 'textarea',
              span: 24,
              minRows: 4,
              maxlength: 300,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "库存物品为零是否显示",
              prop: "emptyDisplayFlag",
              hide: true,
              labelWidth: 170,
              viewDisplay: true,
              span: 24,
              dataType: 'number',
              type: 'radio',
              rules: [{
                required: true,
                message: "请选择库存物品为零是否显示",
                trigger: "change"
              }],
              dicData: [
                {label: '显示', value: 1},
                {label: '不显示', value: 0},
              ],
            },
            // {
            //   label: "库存物品为零是否显示1",
            //   prop: "emptyDisplayFlag1",
            //   hide: true,
            //   labelWidth: 170,
            //   addDisplay: false,
            //   editDisplay: false,
            //   viewDisplay: true,
            //   span: 24,
            //   dataType: 'number',
            //   formslot: true,
            //
            //
            // },
            {
              label: "计价方式",
              prop: "outboundPriceStrategy",
              span: 24,
              hide: true,
              labelWidth: 170,
              //viewDisplay: false,
              dataType: 'number',
              type: 'radio',
              dicUrl: '/api/blade-system/dict/dictionary?code=warehouse_price_type',
              rules: [{
                required: true,
                message: "请选择计价方式",
                trigger: "change"
              }],
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },

            },



          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.warehouse_add, true),
          viewBtn: this.vaildData(this.permission.warehouse_view, true),
          delBtn: this.vaildData(this.permission.warehouse_delete, false),
          editBtn: this.vaildData(this.permission.warehouse_edit, true)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },

    created() {
      //加载列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        this.projectName = this.projectList[0].name;
        this.query.projectId = this.projectList[0].id;
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
        }
        this.$nextTick(() => {
            this.reWrite = true;
            // setTimeout(()=>{
            //   this.$refs.crud.$children[1].$children[4].$el.addEventListener("click", ()=>{
                    
            //         if(this.option.height == this.bodyHeight - 390){
            //           this.option.height = this.bodyHeight - 334
            //         }else{
            //           this.option.height = this.bodyHeight - 390;
            //         }
            //         this.$refs.crud.getTableHeight();
            //     });
            //   })
        
        });
        // this.option.height = this.bodyHeight - 368;
        // this.$nextTick(() => {
        //   this.reWrite = true;
        // });
      });
    },

    watch:{
      userList(val,ovl){
        this.form.userIds=val.length>0;
      }
    },

    methods: {

      //批量停用
      stopAll() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定停用选中仓库?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return stop({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      //停用
      stop(row) {

        this.$confirm("确定停用选中仓库?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            return change({id: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success("操作成功!");
          });
      },
      //启用
      start(row) {
        this.$confirm("确定启用选中仓库?", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            return change({id: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success("操作成功!");
          });
      },
      emptyForm(){
        this.userList=[];
        this.form=[];
      },
      beforeClose(done, type) {
        if(this.passCloseDialog){
          done();
          return;
        }else{
          this.$confirm("确定关闭？", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(()=>{
            this.emptyForm();
            this.form = [];
            this.fileDisabled = false;
            done();
          })
        }


        
      },

      searchProjectChange(e) {

        this.query.projectId = e;

      },
      rowSave(row, done, loading) {
        row.userIds=this.userList;
        add(row).then(() => {
          this.passCloseDialog = true;
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {

        row.userIds=this.userList;

        update(row).then(() => {
          this.passCloseDialog = true;
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if(type === 'view'){
          this.flag = false;
          this.passCloseDialog = true;
        }else{
          this.passCloseDialog = false;
        }
        if(type === 'add'||type === 'edit'){
          this.flag = true;
        }
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            console.log(data,111111111111111111111111111111111111)
            this.userList=data.userIds;
          });
        } else if ("add" === type) {
          this.cleanForm();
          setTimeout(() => {
            console.log(this.query.projectId);
            this.form.projectId = this.query.projectId;
          }, 0)
        }
        done();
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },
      searchReset() {
        this.query.name = '';
        this.onLoad();
      },
      searchChange(params, done) {

        params.projectId = this.query.projectId;
        params.projectName = this.query.projectName;
        this.query.name = params.name;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
        if (!this.query.projectId) {
          this.query.projectId = this.query.projectId;
        }
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style lang="scss">
#warehouse2022 {
   .avue-form__menu--center{
    text-align: right;
  }
   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
}

</style>
